import {
  AtsEntitiesInsightsJobPostingsInsightIdEnum,
  AtsGetMainMetricsInsightsQuery,
  AtsJobPostingsInsight,
} from 'generated/resources/graphql'

export const minutesToDays = (minutes?: number | null) =>
  minutes && Math.round(minutes / 14.4) / 100

export const insightsToObject = (data?: AtsGetMainMetricsInsightsQuery) => {
  const result = defaultResults()
  if (!data) return result

  data.ats.jobPostingsInsightsConnection.nodes.forEach((node) => {
    result[node.id] = node
  })

  return result
}

const defaultResults = (): Record<
  AtsEntitiesInsightsJobPostingsInsightIdEnum,
  AtsJobPostingsInsight
> => ({
  ['job_postings']: {
    id: 'job_postings',
    count: 0,
  },
  ['new_job_postings']: {
    id: 'new_job_postings',
    count: 0,
  },
  ['job_postings_with_hiring']: {
    id: 'job_postings_with_hiring',
    count: 0,
  },
  ['offer_time']: {
    id: 'offer_time',
    averageMinutes: null,
  },
  ['hire_time']: {
    id: 'hire_time',
    averageMinutes: null,
  },
  ['last_updated_at']: {
    id: 'last_updated_at',
    date: null,
  },
})
